import React, { Children } from 'react';
import { forwardRef } from '../../../system/forwardRef.es.js';
import { Group } from '../../../primitives/Group/Group.es.js';
import '../../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../../hooks/useNotification/useNotification.es.js';
import '../../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../../utils/assertions.es.js';
import '../../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import { useControlled } from '../../../hooks/useControlled/useControlled.es.js';
import { useId } from '../../../hooks/useId/useId.es.js';
import { RadioGroupProvider } from './RadioGroupContext.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const RadioGroup = forwardRef((props, ref) => {
  const _a = props, {
    children,
    name,
    isInline,
    value,
    defaultValue,
    onChange,
    isDisabled,
    size,
    gutter = "xxs"
  } = _a, rest = __objRest(_a, [
    "children",
    "name",
    "isInline",
    "value",
    "defaultValue",
    "onChange",
    "isDisabled",
    "size",
    "gutter"
  ]);
  const childrenArray = Children.toArray(children);
  const [internalValue, setInternalValue] = useControlled({ value, defaultValue, onChange });
  const handleChange = (event) => {
    setInternalValue(event.currentTarget.value);
  };
  const groupContext = { value: internalValue, name: useId(name), onChange: handleChange, isDisabled, size };
  return /* @__PURE__ */ React.createElement(RadioGroupProvider, {
    value: groupContext
  }, /* @__PURE__ */ React.createElement(Group, __spreadValues({
    ref,
    direction: isInline ? "horizontal" : "vertical",
    gutter,
    role: "radiogroup"
  }, rest), childrenArray.map((child, index) => /* @__PURE__ */ React.createElement(Group.Item, {
    key: `radio-group-item-${index}`
  }, child))));
});
RadioGroup.displayName = "RadioGroup";
var RadioGroup$1 = Object.assign(RadioGroup, {});

export { RadioGroup$1 as default };
//# sourceMappingURL=RadioGroup.es.js.map
